import { createFileRoute } from '@tanstack/react-router';


export const Route = createFileRoute('/app/leads')({
  // Deep-link contract: ?status=new|open|closed presets the active tab (New is
  // the default when absent). ?kind=inquiry|part_request presets the kind segment
  // (#281; absent = All). Anything else falls back to the default in the page.
  validateSearch: (search) => ({
    status: typeof search.status === 'string' ? search.status : undefined,
    kind: typeof search.kind === 'string' ? search.kind : undefined,
  }),
});
